import * as martinez from 'martinez-polygon-clipping';
import { createCirclePolygon, createRectPolygon } from './shapes.js';
export const createOvalCylinderHolePolygon = (hole)=>{
    const { $absCoords: center, width, height } = hole;
    const widthHalf = width / 2;
    const rectHeight = height - width;
    const rectHeightHalf = rectHeight / 2;
    const topCircle = createCirclePolygon({
        center: {
            x: center.x,
            y: center.y + rectHeightHalf
        },
        radius: widthHalf
    });
    const rect = createRectPolygon({
        center,
        width,
        height: rectHeight
    });
    const bottomCircle = createCirclePolygon({
        center: {
            x: center.x,
            y: center.y - rectHeightHalf
        },
        radius: widthHalf
    });
    const allShapes = [
        topCircle,
        rect,
        bottomCircle
    ];
    return allShapes.reduce(martinez.union);
};

//# sourceMappingURL=oval-cylinder-hole.js.map